import { Box, Flex, Text } from '@chakra-ui/react'
import Image from 'next/image'

const Features = () => {
  return (
    <>
      <Flex
        w={'100%'}
        flexDir={{
          base: 'column',
          md: 'row'
        }}
        gap={5}
        pt={62}
        justifyContent="space-between"
      >
        <Flex gap={1}>
          <Box>
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/traditinal-item-1730878606586.png'
              }
              alt="traditional item"
              width={71}
              height={66}
            />
          </Box>

          <Flex flexDir="column" h="100%" justifyContent={'center'}>
            <Text flex={1} textStyle="supplementFeature">
              传统草药制成
            </Text>
            <Text flex={1} textStyle="supplementFeature">
              TRADITIONAL HERBS
            </Text>
          </Flex>
        </Flex>

        <Flex gap={1}>
          <Box>
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/plant-item-1730878606585.png'
              }
              alt="PLANT-BASED CAPSULES*"
              width={71}
              height={66}
            />
          </Box>

          <Flex flexDir="column" h="100%" justifyContent={'center'}>
            <Text flex={1} textStyle="supplementFeature">
              素食胶囊
            </Text>
            <Text flex={1} textStyle="supplementFeature">
              PLANT-BASED CAPSULES*
            </Text>
          </Flex>
        </Flex>

        <Flex gap={1}>
          <Box>
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/jp-item-1730878606585.png'
              }
              alt="traditional item"
              width={71}
              height={66}
            />
          </Box>

          <Flex flexDir="column" h="100%" justifyContent={'center'}>
            <Text flex={1} textStyle="supplementFeature">
              日本制造
            </Text>
            <Text flex={1} textStyle="supplementFeature">
              MADE IN JAPAN
            </Text>
          </Flex>
        </Flex>
      </Flex>

      <Flex
        w={'100%'}
        flexDir={'column'}
        pb={58}
        justifyContent="center"
        alignItems="center"
        mt={5}
      >
        <Text textAlign={'center'}>
          *All products are plant based capsules suitable for vegetarian except
          for Uric Acid.
        </Text>
        <Text textAlign={'center'}>所有产品均为素食胶囊 ,除了尿酸清.</Text>

        <Text></Text>
      </Flex>
    </>
  )
}

export default Features
